const getEditBasketValidationMessage = state => state?.editBasket?.validationMessage;

export default getEditBasketValidationMessage;
